import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Submit extends Component{
	constructor(props){
		super(props);
		this.clickHandle = this.clickHandle.bind(this);
	}

	clickHandle(e){ //method for handling button click
		this.props.onClick(this.props.identity);
	}

	render(){
		return(
			<div className="tc">
				<button className={this.props.styles} onClick={this.clickHandle} disabled={this.props.disable}>{this.props.name}</button>
			</div>
		);
	}
}

Submit.propTypes = {
	onClick: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	disable: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.bool
	])
};


// WEBPACK FOOTER //
// ./src/component/Submit.js